export default "__VITE_ASSET__CLzU6R2n__"